import { createConsumer } from "@rails/actioncable"

const websocket = createConsumer('/cable')

export default websocket
